<template>
    <div class="modal fade game-point-note-modal" id="offer_pop_up" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-sm modal-dialog-centered">
            <div class="modal-content" style="border: none;">
                <div class="modal-body p-0">
                    <div class="sub-header-wrapper">
                        <div class="offer_banner_container">
                            <img data-bs-dismiss="modal" @click="closeOffer()" class="gp-closeButton" src="@/assets/images/closeButton.svg" alt="">
                            <div class="sub-header-wrapper" v-if="siteSettings?.offer?.image">
                                <div class="offer_banner_img">
                                    <img :src="siteSettings.aws_url + siteSettings.storage_path.offer_path + siteSettings.offer?.image" class="offer-img" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            siteSettings: 'siteSettings',
        }),
    },
    methods: {
        closeOffer(){
            localStorage.setItem('is_offer', false);
        }
    }
}
</script>